import { parseISO } from 'date-fns';
import { JobIncidentMediaVM } from '@app/models';
import { createSelector } from '@ngrx/store';
import { jobIncidentMediaSelectors } from './job-incident-media.state';
import { userSelectors } from './user.state';

export const selectJobIncidentMediaVMAll = createSelector(
  jobIncidentMediaSelectors.selectAll,
  userSelectors.selectEntities,
  (incidentMedia, users): JobIncidentMediaVM[] => {
    return incidentMedia.map(
      (media): JobIncidentMediaVM => {
        return {
          ...media,
          thumbnails: media.thumbnails ? { ...media.thumbnails } : null,
          employee: media.employee in users ? users[media.employee] : null,
          created: media.created ? parseISO(media.created) : null,
        };
      }
    );
  }
);

export const selectJobIncidentVMMediaByIncident = createSelector(
  selectJobIncidentMediaVMAll,
  incidents => {
    const result: { [key: string]: JobIncidentMediaVM[] } = {};
    incidents.forEach(incident => {
      if (!(incident.jobIncident in result)) {
        result[incident.jobIncident] = [];
      }
      result[incident.jobIncident].push(incident);
    });
    return result;
  }
);
